"use client"

import amplifyOutputs from "amplify_outputs.json" with { type: "json" }
import { Amplify, type ResourcesConfig } from "aws-amplify"
import type { AmplifyOutputsUnknown, LegacyConfig } from "aws-amplify/adapter-core/internals"
import { notFound } from "next/navigation.js"
import { useContext } from "react"
import Application from "../main/typescript/component/Application.js"
import FaceLivenessDetectionRedirect from "../main/typescript/component/FaceLivenessDetectionRedirect.js"
import FaceSignatureRedirect from "../main/typescript/component/FaceSignatureRedirect.js"
import ConfigurationContext from "../main/typescript/context/ConfigurationContext.js"
import RouterContext from "../main/typescript/context/RouterContext.js"
import useLocation from "../main/typescript/hook/UseLocation.js"
import { LocaleCodeSchema } from "../main/typescript/schemata/shared/LocaleSchema.js"
import Validate from "../main/typescript/support/language/Validate.js"

// Initializes and configures the Amplify client.
Amplify.configure(amplifyOutputs as ResourcesConfig | LegacyConfig | AmplifyOutputsUnknown, { ssr: false })

/**
 * @description
 *	This is the main page of the entire application.
 */
export default function Page() {
	const defaultConfiguration = useContext(ConfigurationContext)
	const uri = useLocation()
	const locale = Validate(LocaleCodeSchema, uri?.queryParameters.get("locale"))
	const configuration = locale ? { ...defaultConfiguration, DEFAULT_LOCALE: locale } : defaultConfiguration
	if (uri?.path) {
		switch (uri.path) {
			case "/":
				return (
					<ConfigurationContext.Provider value={configuration}>
						<RouterContext.Provider value={uri}>
							<Application />
						</RouterContext.Provider>
					</ConfigurationContext.Provider>
				)
			case "/redirect/face-liveness-detection":
				return (
					<ConfigurationContext.Provider value={configuration}>
						<RouterContext.Provider value={uri}>
							<FaceLivenessDetectionRedirect />
						</RouterContext.Provider>
					</ConfigurationContext.Provider>
				)
			case "/redirect/face-signature":
				return (
					<ConfigurationContext.Provider value={configuration}>
						<RouterContext.Provider value={uri}>
							<FaceSignatureRedirect />
						</RouterContext.Provider>
					</ConfigurationContext.Provider>
				)
			default:
				notFound()
		}
	}
}
